import * as dataSource from './datasource';
import { Brands } from 'src/utils/enums/brands.enum';
import { Checkbox } from '../../../ui/checkbox';
import { ComboBox } from '../../../ui/combobox';
import { CreditAppService } from '../../../../services/credit-app.service';
import FormSectionPage from '../../ui/formSectionPage';
import i18n from 'i18next';
import Input from 'src/components/forms/input';
import { IUser } from '../../../../utils/interfaces/user';
import { RadioButton } from '../../../ui/radioButton';
import Spinner from 'src/components/ui/spinner/index';
import { TERMDATE_ITEM_NAME } from 'src/config';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useFormik } from 'formik';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { vehicleInfoValidations } from './validations';
import {
    getBrandByDealerNumber,
    isSiteCanadian,
} from '../../../../utils/helpers';
import {
    getCurrentBodyType,
    getCurrentModel,
    getCurrentYear,
    getSelectedBodyType,
    ModelEntry,
} from '../utils';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import './style.scss';
export interface IVehicleInfo {
    applicationType: string;
    vehicleType: string;
    setVehicleType: any;
    vehicleYear: string;
    setVehicleYear: any;
    setVehicleData: Function;
    setVehicleValid: Function;
    isOpen: boolean;
    setOpen: Function;
    setVehicleMake: Dispatch<SetStateAction<string>>;
    vehicleMake: string;
    isBlocked?: boolean;
    initialVehicle?: any;
    isFormDisabled?: boolean;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

type VehicleTypeOption = {
    value: 'New' | 'PreOwned' | 'CPO' | 'Demo';
    label: string;
};

/***** WILL BE REPLACED WITH EXTERNAL DATASOURCE ****/
const MINUS_ONE = -1;
/*****************************************************/

const VehicleInfo: React.FC<IVehicleInfo> = ({
    applicationType,
    vehicleType,
    setVehicleType,
    vehicleYear,
    setVehicleYear,
    setVehicleData,
    setVehicleValid,
    isOpen,
    setOpen,
    setVehicleMake,
    vehicleMake,
    isBlocked = false,
    initialVehicle = null,
    isEditMode = false,
    isFormDisabled = false,
    disablePrintAndSubmitBtn,
}) => {
    const { vehicleInformation } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const [makes, setMakes] = useState([]);
    const [years, setYears] = useState([]);
    const [isLoading, seIsLoading] = useState<boolean>(() => {
        return initialVehicle ? true : false;
    });
    const [shouldBlockVehicleOnce, setShouldBlockVehicleOnce] =
        useState<boolean>(false);
    const [disabledForm, setDisabledForm] = useState<boolean>(isFormDisabled);
    const [vehicleModel, setVehicleModel] = useState<string>('');
    const [vehicleBodyType, setVehicleBodyType] = useState<string>('');
    const [vehicleAuction, setVehicleAuction] = useState<boolean>(false);
    const [vehicleModelOptions, setVehicleModelOptions] = useState<string[]>([
        '',
    ]);
    const [vehicleBodyOptions, setVehicleBodyOptions] = useState<string[]>([
        '',
    ]);
    const [showicon, setShowIcon] = useState<boolean | null>(null);
    const [submitErrors, setSubmitErrors] = useState({
        vehicleMileage: '',
        vehicleVin: '',
    });
    const initialVehicleTypes: VehicleTypeOption[] = [
        { value: 'New', label: vehicleInformation.TYPE_NEW },
        { value: 'PreOwned', label: vehicleInformation.TYPE_PRE },
    ];
    const [optionsvehicleType, setOptionsvehicleType] =
        useState<VehicleTypeOption[]>(initialVehicleTypes);
    const dealer = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer;
    });
    const isCanada = dealer?.country === 'Canada' || dealer?.country === 'CA';
    const isDucati =
        dealer &&
        getBrandByDealerNumber(dealer.brand, dealer.dealerNumber) ===
            Brands.DUCATI.toLowerCase();
    const verifyModelChange = () => {
        if (vehicleMake == '' || vehicleYear == '' || vehicleType == null) {
            setVehicleModelOptions([]);
            return;
        }

        if (!years.length) {
            return;
        }

        const currentYear: any = getCurrentYear(years, vehicleYear);
        const currentModels: any = currentYear?.models.map(
            (ele: ModelEntry) => ele.model,
        );
        const currentModel: any = getCurrentModel(currentYear, vehicleModel);

        const shouldSetInitial = initialVehicle && !shouldBlockVehicleOnce;
        const modelSelected =
            shouldSetInitial && currentModel ? initialVehicle?.Model : '';

        setVehicleModel(modelSelected);
        setFieldValue('vehicleModel', modelSelected);

        if (currentYear) {
            setVehicleModelOptions(currentModels);

            const selectedBodyType = getSelectedBodyType(
                shouldSetInitial,
                currentModel,
                initialVehicle?.BodyType,
            );

            if (isEditMode && !selectedBodyType && !isOpen) {
                setOpen(true);
            }
            setVehicleBodyType(selectedBodyType);
            setFieldValue('vehicleBody', selectedBodyType);
            setVehicleBodyOptions([]);

            if (!currentModel?.bodyTypes) {
                setShouldBlockVehicleOnce(true);
            }
        }
    };

    const verifyBodyChange = () => {
        if (
            vehicleMake != '' &&
            vehicleYear !== '' &&
            vehicleType != null &&
            vehicleModel != ''
        ) {
            if (!years.length) {
                return;
            }

            setVehicleBodyOptions([]);

            const currentYear: any = getCurrentYear(years, vehicleYear);
            const currentModel: any = getCurrentModel(
                currentYear,
                vehicleModel,
            );

            const shouldSetInitial = initialVehicle && !shouldBlockVehicleOnce;

            const selectedBodyType = getSelectedBodyType(
                shouldSetInitial,
                currentModel,
                initialVehicle?.BodyType,
            );

            setVehicleBodyType(selectedBodyType);
            setFieldValue('vehicleBody', selectedBodyType);

            if (currentYear) {
                setVehicleBodyOptions(currentModel?.bodyTypes || []);

                if (!currentModel?.bodyTypes) {
                    setShouldBlockVehicleOnce(true);
                }
            }
        } else {
            setVehicleBodyOptions([]);
        }
    };

    async function getMakes() {
        if (dealer && dealer.dealerNumber) {
            const service = new CreditAppService();
            const res = await service.getMakes(
                dealer.dealerNumber,
                dealer?.brand,
                dealer?.country,
                vehicleType,
            );
            if (res && res.data) {
                if (dealer.country === 'Canada')
                    setMakes(
                        res.data.filter((ele: string) => {
                            if (ele.toLocaleLowerCase() !== 'bentley')
                                return ele;
                        }),
                    );
                else setMakes(res.data);
            }
        }
    }

    const setVehicleInfo = (vehicleMake: string, fieldValue: string) => {
        if (initialVehicle && !shouldBlockVehicleOnce) {
            setVehicleMake(validateMakeDucati(initialVehicle?.Make));
            setFieldValue(
                'vehicleMake',
                validateMakeDucati(initialVehicle?.Make),
            );
        } else {
            setVehicleMake(validateMakeDucati(vehicleMake));
            setFieldValue('vehicleMake', validateMakeDucati(fieldValue));
        }
    };

    function validateMakeDucati(value: string) {
        if (!isCanada && isDucati) {
            return value;
        }

        return value.toLowerCase().includes('ducati')
            ? dataSource.brands[1].brand
            : value;
    }

    function makeSelection() {
        if (!makes.length) {
            return;
        }
        if (vehicleType === optionsvehicleType[1].value) {
            setVehicleInfo(vehicleInformation.MAKE_DEAFULT, '');
            setYears([]);
        } else {
            let pos = -1;
            switch (dealer?.brand.toUpperCase()) {
                case 'VW':
                    pos = makes.findIndex(
                        (ele) => ele === dataSource.brands[0].label,
                    );
                    break;
                case 'AUDI':
                    pos = makes.findIndex(
                        (ele) => ele === dataSource.brands[1].label,
                    );
                    break;
                case 'DUCATI':
                    pos = makes.findIndex(
                        (ele) => ele === dataSource.brands[2].label,
                    );
                    break;
            }
            if (pos > MINUS_ONE) {
                setVehicleInfo(makes[pos], makes[pos]);
            }
        }
        if (initialVehicle && !shouldBlockVehicleOnce) {
            setVehicleYear(initialVehicle?.Year);
            setFieldValue('vehicleYear', initialVehicle?.Year);
        } else {
            setVehicleYear('');
            setFieldValue('vehicleYear', '');
        }
    }

    async function getMakeInfo() {
        if (dealer && vehicleMake.length) {
            setVehicleBodyOptions([]);
            setVehicleModelOptions([]);
            setVehicleYear('');
            setFieldValue('vehicleYear', '');
            setYears([]);
            const service = new CreditAppService();
            const res = await service.getMakesInfo(
                dealer.dealerNumber,
                vehicleMake.toLocaleUpperCase(),
                dealer?.brand,
                dealer?.country,
                vehicleType,
            );
            if (res && res.data) {
                const localYears = res.data.years;
                setYears(localYears);

                const shouldSetInitial =
                    initialVehicle && !shouldBlockVehicleOnce;

                let currentModel: any = null;
                let currentBodyType = null;

                if (shouldSetInitial) {
                    const currentYear: any = getCurrentYear(
                        localYears,
                        vehicleYear,
                    );
                    currentModel = getCurrentModel(
                        currentYear,
                        initialVehicle?.Model,
                    );
                    currentBodyType = getCurrentBodyType(
                        currentModel,
                        initialVehicle?.BodyType,
                    );
                }

                const selectedModel =
                    shouldSetInitial && currentModel
                        ? initialVehicle?.Model
                        : '';

                const selectedBodyType =
                    shouldSetInitial && currentModel && currentBodyType
                        ? initialVehicle?.BodyType
                        : '';

                setVehicleModel(selectedModel);
                setFieldValue('vehicleModel', selectedModel);

                setVehicleBodyType(selectedBodyType);
                setFieldValue('vehicleBody', selectedBodyType);

                sessionStorage.setItem(TERMDATE_ITEM_NAME, res.data.termDate);
            }
        }
    }

    useEffect(() => {
        if (dealer) {
            const option = (
                value: VehicleTypeOption['value'],
                label: string,
            ): VehicleTypeOption => ({ value, label });

            const vehicleTypes: VehicleTypeOption[] = [
                ...initialVehicleTypes,
                ...(!isDucati
                    ? [option('CPO', vehicleInformation.TYPE_CPO)]
                    : []),
                ...(isCanada
                    ? [option('Demo', vehicleInformation.TYPE_DEMO)]
                    : []),
            ];
            setOptionsvehicleType(vehicleTypes);
        }
    }, [dealer]);

    useEffect(() => {
        getMakes();
    }, [vehicleType]);
    useEffect(() => {
        if (makes.length) {
            const makeLower = vehicleMake.toLocaleLowerCase();

            if (
                !makeLower.includes('select make') &&
                !makeLower.includes('sélectionner la marque')
            ) {
                makeSelection();

                if (vehicleType !== optionsvehicleType[1].value) {
                    getMakeInfo();
                }
            }
        }
    }, [makes, vehicleType]);
    useEffect(() => {
        if (applicationType != '' && !initialVehicle) {
            getMakes();
        }
    }, [applicationType]);
    useEffect(() => {
        makeSelection();
        verifyModelChange();
        verifyBodyChange();
    }, [vehicleType]);
    useEffect(() => {
        if (vehicleMake === vehicleInformation.MAKE_DEAFULT) return;
        verifyModelChange();
        verifyBodyChange();
        getMakeInfo();
    }, [vehicleMake]);
    useEffect(() => {
        verifyModelChange();
        verifyBodyChange();
    }, [vehicleYear]);
    useEffect(() => {
        verifyBodyChange();
    }, [vehicleModel]);
    useEffect(() => {
        touched.vehicleYear = false;
    }, [years]);
    useEffect(() => {
        touched.vehicleModel = false;
    }, [vehicleModelOptions]);
    useEffect(() => {
        touched.vehicleBody = false;
    }, [vehicleBodyOptions]);

    //for edit mode
    useEffect(() => {
        if (initialVehicle && !shouldBlockVehicleOnce) {
            setFieldValue('vehicleMileage', initialVehicle?.Mileage);
            setFieldValue('vehicleVin', initialVehicle?.VIN?.Number);
            if (years.length && years[0] !== '') {
                setVehicleYear(initialVehicle?.Year);
                setFieldValue('vehicleYear', initialVehicle?.Year);
            }
            if (vehicleModelOptions.length && vehicleModelOptions[0] !== '') {
                setVehicleModel(initialVehicle?.Model);
                setFieldValue('vehicleModel', initialVehicle?.Model);
            }
        }
    }, [years]);

    //for edit mode
    useEffect(() => {
        if (initialVehicle && !shouldBlockVehicleOnce) {
            if (vehicleBodyOptions.length && vehicleBodyOptions[0] !== '') {
                let currentModel: any = null;
                let currentBodyType = null;

                const currentYear: any = getCurrentYear(years, vehicleYear);
                currentModel = getCurrentModel(
                    currentYear,
                    initialVehicle?.Model,
                );
                currentBodyType = getCurrentBodyType(
                    currentModel,
                    initialVehicle?.BodyType,
                );

                const selectedBodyType =
                    currentModel && currentBodyType
                        ? initialVehicle?.BodyType
                        : '';
                if (isEditMode && !selectedBodyType && !isOpen) {
                    setOpen(true);
                }
                setVehicleBodyType(selectedBodyType);
                setFieldValue('vehicleBody', selectedBodyType);
                setShouldBlockVehicleOnce(true);
            }
        }
    }, [vehicleBodyOptions]);

    //for edit mode
    useEffect(() => {
        if (initialVehicle && shouldBlockVehicleOnce) {
            seIsLoading(false);
        }
    }, [shouldBlockVehicleOnce]);

    const allFieldsValid = () => {
        if (vehicleMake == '') {
            return false;
        }

        if (vehicleYear == '') {
            return false;
        }

        if (vehicleModel == '') {
            return false;
        }

        if (vehicleBodyType == '') {
            return false;
        }
        return true;
    };

    const buildAndSetVehicleData = () => {
        let vehicleMileage, vehicleVin;

        if (values.vehicleMileage) {
            vehicleMileage = +values.vehicleMileage;
        }
        if (values.vehicleVin) {
            vehicleVin = values.vehicleVin;
        }
        let vehicleData = {
            vehicleMileage,
            vehicleVin,
            vehicleType,
            vehicleMake,
            vehicleYear,
            vehicleModel,
            vehicleBodyType,
        };
        if (!isSiteCanadian() && vehicleType == 'PreOwned') {
            vehicleData = {
                ...vehicleData,
                ...{ vehicleAuction },
            };
        }
        setVehicleData(vehicleData);
    };

    const handleCustomSubmit = () => {
        setSubmitErrors({
            vehicleMileage: '',
            vehicleVin: '',
        });

        if (allFieldsValid()) {
            buildAndSetVehicleData();
            setShowIcon(true);
            setDisabledForm(true);
            setOpen(false);
            setVehicleValid(true);
        } else {
            setShowIcon(false);
        }
    };

    const onEdit = () => {
        setVehicleValid(false);
        setDisabledForm(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };

    useEffect(() => {
        if (isEditMode && !isLoading) {
            buildAndSetVehicleData();
        }
    }, [isEditMode, isLoading]);

    const {
        values,
        errors,
        touched,
        handleSubmit,
        handleBlur,
        setFieldValue,
        setFieldTouched,
    } = useFormik({
        initialValues: {
            vehicleMileage: '',
            vehicleVin: '',
            vehicleYear: '',
            vehicleMake: '',
            vehicleBody: '',
            vehicleModel: '',
        },
        validationSchema: vehicleInfoValidations,
        onSubmit: handleCustomSubmit,
        validateOnChange: false,
        validateOnBlur: false,
    });

    useEffect(() => {
        const handleLanguageChange = () => {
            Object.keys(errors).forEach((field) => {
                setFieldTouched(field, true, true);
            });
        };

        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n, errors, setFieldTouched]);

    const Template = (): JSX.Element => {
        return (
            <fieldset disabled={disabledForm}>
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field  c-form-field--no-floating  '>
                                <label
                                    htmlFor='m1lh7pdb'
                                    className='c-form-field__label'
                                >
                                    {vehicleInformation.TYPE_LABEL}
                                </label>
                                <div className='c-form-field__box'>
                                    <RadioButton
                                        name={'typeRadio'}
                                        options={optionsvehicleType.map(
                                            (vehicle) => vehicle.value,
                                        )}
                                        onSelect={(option) => {
                                            markCreditFormTouched();
                                            setVehicleType(option);
                                        }}
                                        selectedOption={vehicleType}
                                        labels={optionsvehicleType.map(
                                            (vehicle) => vehicle.label,
                                        )}
                                        disabled={
                                            initialVehicle || disabledForm
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field'>
                                <label
                                    htmlFor='m1l7e063'
                                    className='c-form-field__label'
                                >
                                    {vehicleInformation.MAKE_LABEL}
                                </label>
                                <div className='c-form-field__box'>
                                    <div className='c-input  '>
                                        <ComboBox
                                            name={'vehicleMakeSelector'}
                                            options={makes}
                                            defaultValue={vehicleMake}
                                            placeholder={
                                                vehicleInformation.MAKE_DEAFULT
                                            }
                                            onSelect={(value) => {
                                                setVehicleMake(value);
                                                setFieldValue(
                                                    'vehicleMake',
                                                    value,
                                                );
                                                markCreditFormTouched();
                                            }}
                                            selectedOption={vehicleMake}
                                            disabled={
                                                vehicleType !==
                                                    optionsvehicleType[1]
                                                        .value || disabledForm
                                            }
                                        />
                                    </div>
                                    <div
                                        className='custom-input-error'
                                        hidden={
                                            !(
                                                errors.vehicleMake &&
                                                errors.vehicleMake?.length >
                                                    Number('0') &&
                                                touched.vehicleMake
                                            )
                                        }
                                    >
                                        {vehicleInformation.REQUIRED_ERR_LABEL}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field '>
                                <label
                                    htmlFor='m1l7e063'
                                    className='c-form-field__label'
                                >
                                    {vehicleInformation.YEAR_LABEL}
                                </label>
                                <div className='c-form-field__box'>
                                    <div className='c-input  '>
                                        <ComboBox
                                            name={'year'}
                                            options={years.map((ele: any) => {
                                                return ele.year;
                                            })}
                                            defaultValue={''}
                                            placeholder={
                                                vehicleInformation.YEAR_DEAFULT
                                            }
                                            selectedOption={vehicleYear}
                                            onSelect={(value) => {
                                                setVehicleYear(value);
                                                setFieldValue(
                                                    'vehicleYear',
                                                    value,
                                                );
                                                markCreditFormTouched();
                                            }}
                                            disabled={disabledForm}
                                            hasError={
                                                !!(
                                                    errors.vehicleYear &&
                                                    errors.vehicleYear?.length >
                                                        Number('0') &&
                                                    touched.vehicleYear
                                                )
                                            }
                                        />
                                    </div>
                                    <div
                                        className='custom-input-error'
                                        hidden={
                                            !(
                                                errors.vehicleYear &&
                                                errors.vehicleYear?.length >
                                                    Number('0') &&
                                                touched.vehicleYear
                                            )
                                        }
                                    >
                                        {vehicleInformation.REQUIRED_ERR_LABEL}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field'>
                                <label
                                    htmlFor='m1l7e063'
                                    className='c-form-field__label'
                                >
                                    {vehicleInformation.MODEL_LABEL}
                                </label>
                                <div className='c-form-field__box'>
                                    <div className='c-input  '>
                                        <ComboBox
                                            name={'vehicleModelSelector'}
                                            options={vehicleModelOptions}
                                            defaultValue={''}
                                            placeholder={
                                                vehicleInformation.MODEL_DEAFULT
                                            }
                                            onSelect={(value) => {
                                                setVehicleModel(value);
                                                setFieldValue(
                                                    'vehicleModel',
                                                    value,
                                                );
                                                markCreditFormTouched();
                                            }}
                                            selectedOption={vehicleModel}
                                            disabled={disabledForm}
                                            hasError={
                                                !!(
                                                    errors.vehicleModel &&
                                                    errors.vehicleModel
                                                        ?.length >
                                                        Number('0') &&
                                                    touched.vehicleModel
                                                )
                                            }
                                        />
                                    </div>
                                    <div
                                        className='custom-input-error'
                                        hidden={
                                            !(
                                                errors.vehicleModel &&
                                                errors.vehicleModel?.length >
                                                    Number('0') &&
                                                touched.vehicleModel
                                            )
                                        }
                                    >
                                        {vehicleInformation.REQUIRED_ERR_LABEL}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field '>
                                <label
                                    htmlFor='m1l7e063'
                                    className='c-form-field__label'
                                >
                                    {vehicleInformation.BODY_LABEL}
                                </label>
                                <div className='c-form-field__box'>
                                    <div className='c-input  '>
                                        <ComboBox
                                            name={'vehicleBodySelector'}
                                            options={vehicleBodyOptions}
                                            defaultValue={''}
                                            placeholder={
                                                vehicleInformation.BODY_DEAFULT
                                            }
                                            onSelect={(value) => {
                                                setVehicleBodyType(value);
                                                setFieldValue(
                                                    'vehicleBody',
                                                    value,
                                                );
                                                markCreditFormTouched();
                                            }}
                                            selectedOption={vehicleBodyType}
                                            disabled={disabledForm}
                                            hasError={
                                                !!(
                                                    errors.vehicleBody &&
                                                    errors.vehicleBody?.length >
                                                        Number('0') &&
                                                    touched.vehicleBody
                                                )
                                            }
                                        />
                                    </div>
                                    <div
                                        className='custom-input-error'
                                        hidden={
                                            !(
                                                errors.vehicleBody &&
                                                errors.vehicleBody?.length >
                                                    Number('0') &&
                                                touched.vehicleBody
                                            )
                                        }
                                    >
                                        {vehicleInformation.REQUIRED_ERR_LABEL}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='o-fieldset__row input-end'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                vehicleInformation.MILEAGE_LABEL
                                            }
                                            type={'text'}
                                            name={'vehicleMileage'}
                                            handlerChange={(e: any) => {
                                                e.preventDefault();
                                                const regex = new RegExp(
                                                    '^[0-9]{0,6}$',
                                                );
                                                const { value } = e.target;
                                                if (regex.test(value)) {
                                                    setFieldValue(
                                                        'vehicleMileage',
                                                        value,
                                                    );
                                                }
                                                markCreditFormTouched();
                                            }}
                                            handlerBlur={handleBlur}
                                            value={values.vehicleMileage}
                                            asErrors={errors.vehicleMileage}
                                            asTouched={touched.vehicleMileage}
                                            asSubmitError={
                                                submitErrors.vehicleMileage
                                            }
                                            handleKeyPress={() => {
                                                setFieldTouched(
                                                    'vehicleMileage',
                                                );
                                            }}
                                            sufix={
                                                isSiteCanadian() ? 'kms' : 'mi'
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                vehicleInformation.VIN_LABEL
                                            }
                                            type={'text'}
                                            name={'vehicleVin'}
                                            handlerChange={(e: any) => {
                                                markCreditFormTouched();
                                                const regex = new RegExp(
                                                    '^[A-Z0-9]*$',
                                                );
                                                const { value } = e.target;
                                                const uppercaseValue =
                                                    value.toUpperCase();
                                                if (
                                                    regex.test(uppercaseValue)
                                                ) {
                                                    setFieldValue(
                                                        'vehicleVin',
                                                        uppercaseValue,
                                                    );
                                                }
                                            }}
                                            handlerBlur={handleBlur}
                                            value={values.vehicleVin}
                                            asErrors={errors.vehicleVin}
                                            asTouched={touched.vehicleVin}
                                            asSubmitError={
                                                submitErrors.vehicleVin
                                            }
                                            handleKeyPress={() => {
                                                setFieldTouched('vehicleVin');
                                            }}
                                            maxlength={17}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!isSiteCanadian() && vehicleType == 'PreOwned' && (
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <div className='c-form-field'>
                                    <div className='c-form-field__box'>
                                        <div className='c-input'>
                                            <Checkbox
                                                name={
                                                    vehicleInformation.OPTION_AUCTION
                                                }
                                                value={'auctionCheck'}
                                                onCheck={setVehicleAuction}
                                                checked={vehicleAuction}
                                                allBlack={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </fieldset>
        );
    };

    return (
        <>
            {isLoading ? (
                <div className='spinner-container'>
                    <Spinner />
                </div>
            ) : (
                <FormSectionPage
                    title={vehicleInformation.TITLE}
                    handlerSubmit={handleSubmit}
                    isOpen={isOpen}
                    setOpen={setOpen}
                    showIcon={showicon}
                    isDisabled={disabledForm}
                    onEdit={onEdit}
                    isEditMode={isEditMode}
                    isBlocked={isBlocked}
                    disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
                    focusOnOpen={false}
                >
                    {Template()}
                </FormSectionPage>
            )}
        </>
    );
};

export default VehicleInfo;
